import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { SearchItem } from '@rivethealth/data/ui-search-item';
import { AnchoredPosition } from '../callout/callout-position';

enum Key {
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './autocomplete-list.component.html',
  styleUrls: ['./autocomplete-list.component.scss'],
})
export class AutoCompleteListComponent {
  public list: SearchItem[] = [];
  public width = 'auto';
  public anchor: Element;
  preferredPosition: AnchoredPosition;
  selectedItem: number = 0;

  constructor(private readonly changeDetector: ChangeDetectorRef) {}

  @ViewChildren('listItem') listItems: QueryList<ElementRef>;

  @Output('selected') selected = new EventEmitter<SearchItem>();
  @Output('highlighted') highlighted = new EventEmitter<SearchItem>();
  @Output('clear') clear = new EventEmitter<void>();

  private loopClamp(next: number, max: number): number {
    if (next < 0) {
      return max;
    } else if (next > max) {
      return 0;
    } else {
      return next;
    }
  }

  handleArrows = (key: string) => {
    const max = this.list.length - 1;
    if (key == Key.ARROW_UP) {
      this.selectedItem = this.loopClamp(
        this.selectedItem === null ? max : this.selectedItem - 1,
        max,
      );
    }
    if (key == Key.ARROW_DOWN) {
      this.selectedItem = this.loopClamp(
        this.selectedItem === null ? 0 : this.selectedItem + 1,
        max,
      );
    }
    this.highlighted.emit(this.list[this.selectedItem]);
    const arr = this.listItems.toArray();
    if (this.selectedItem < arr.length) {
      arr[this.selectedItem].nativeElement.scrollIntoView(false);
    }
    this.render();
  };

  handleEnter = () => {
    if (this.selectedItem == null) {
      return false;
    }
    this.selected.emit(this.list[this.selectedItem]);
    return true;
  };

  render() {
    this.changeDetector.markForCheck();
  }

  delayClear = (): any => setTimeout(() => this.clear.emit(), 100);
}
